// src/pages/Quality.jsx
import React from "react";
import innerBanner from "../Images/inner-banner-image.jpg";
import Footer from "../Components/Footer";
import qualityImage from "../Images/Quality-image.png";
import qualityImage2 from "../Images/quality-image-2.png";

const Quality = () => {
  return (
    <div>
      <div className="inner-banner-section">
        <img src={innerBanner} alt="inner-banner" />
        <div className="inner-banner-heading">
          <span>Quality</span>
        </div>
      </div>
      {/* ------------------------------------------ */}

      <div className="quality-section-1">
        <div className="container">
          <div className="quality-section-1-cont">
            <h1>Laboratory & Quality Assurance</h1>
            <p>
              At M/s Shivasakthi Fashions, quality is at the core of everything
              we do. With two decades of expertise, we ensure precision in color
              matching, superior colorfastness, and excellent knittability. Our
              commitment to high standards, reliable machinery, and efficient
              processes guarantees consistent, top-tier yarn-dyed garments.
            </p>
            <div className="quality-content-section">
              <div className="quality-content-left">
                <p>
                  Quality of final product reigns supreme in dyeing field and
                  Laboratory is the nerve centre of our unit as we decide the
                  course of recipe for the neat production with required
                  fastness properties and batch to batch colour consistency.
                </p>
                <p>
                  Pride of the laboratory is sophisticated instruments like auto
                  dispenser from Color Focus from Taiwan and reliable dyeing
                  machines from Starlet Taiwan, Sandolan from S Korea.
                </p>
                <p>
                  The lab also equipped with Minolta Spectrophoto Meter by which
                  we do recipe prediction through QTX values given by the buyers
                  and submit matching within the DE value demanded.
                </p>
              </div>
              <div className="quality-content-right">
                <div className="quality-right-img">
                  <img src={qualityImage} alt="quality-image" />
           
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ------------------------------------ */}

      <div className="quality-section-2">
        <div className="container">
          <div className="quality-section-2-cont">
            <div className="quality-section-2-left">
              <h2>
                Quality of Raw Materials Dyestuffs <br />
                and Textile Chemicals
              </h2>
              <p>
                Quality input guarantees quality output. Selection of input raw
                materials is carefully done and utilizing them in the correct
                application process ensures all round fastness properties. We
                believe in Blind Dyeing Technique and Practice them without any
                compromise. Laboratory and Production staff is given adequate
                training to get updated in this concept. With export oriented
                customers in focus, the dyes which we use comply with Okotex.
                GOTS and REACH Standards.
              </p>
              <p>
                We also have a process control team to monitor the processing
                throughout the department to ensure monitoring parameters being
                followed during the process which ensures quality of final
                Product.
              </p>
            </div>
            <div className="quality-section-2-right">
              <div className="quality-sec-2-img">
                <img src={qualityImage2} alt="Quality-image" />
                <div className="quality-add-content">
                    <p>
                      Each and every Packages is checked individually on the QC
                      table to ensure all round quality before dispatch.
                    </p>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --------------------------------------- */}

      <Footer />
    </div>
  );
};

export default Quality;
